import { createSelector } from "reselect";

export const brandsSelector = createSelector(
    state => state.services.brand,
    state => state
);